import * as Yup from "yup";

// Regular expressions for validation
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^[a-zA-Z0-9]{8,16}$/;
const cifRegex = /^[A-Z][0-9]{7}[0-9A-Z]$/;
const nifRegex = /^([0-9]{8}[A-Z]|[KLMXYZ][0-9]{7}[A-Z])$/;
const nieRegex = /^[KLMXYZ][0-9]{7}[A-Z]$/;
const passportRegex = /^[A-Z]{2,3}[0-9]{6}$/;
const phoneRegex = /^\+[0-9]{2,3}[0-9]{9}$/;
const numberOnlyRegex = /^[0-9]+$/;

// Create a validation schema for the registration form
export const registrationSchema = Yup.object().shape({
  first_name: Yup.string().required("Este campo es obligatorio"),

  last_name: Yup.string().required("Este campo es obligatorio"),

  second_last_name: Yup.string().optional(),

  email: Yup.string()
    .matches(emailRegex, "Escriba un correo válido")
    .required("Este campo es obligatorio"),

  id_type: Yup.string()
    .oneOf(["CIF", "NIE", "NIF", "Passport"], "Tipo de documento inválido")
    .required("Este campo es obligatorio"),

  id_number: Yup.string()
    .required("Este campo es obligatorio")
    .test(
      "idFormat",
      "Escribe un número de documento válido",
      function (value) {
        const { id_type } = this.parent;

        switch (id_type) {
          // case "CIF":
          //   return cifRegex.test(value);
          case "NIF":
            return nifRegex.test(value);
          case "NIE":
            return nieRegex.test(value);
          case "Passport":
            return passportRegex.test(value);
          default:
            return false;
        }
      }
    ),

  password: Yup.string()
    .matches(
      passwordRegex,
      "Escribe una contraseña alfanumérica de entre 8 a 16 caracteres."
    )
    .required("Este campo es obligatorio"),

  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "La contraseña no coinciden")
    .required("Este campo es obligatorio"),

  mobile_phone: Yup.string()
    .optional()
    .matches(phoneRegex, "Formato: +34 seguido de 9 dígitos. Ej: +34612345678"),

  landline: Yup.string()
    .optional()
    .matches(phoneRegex, "Formato de teléfono inválido. Ej: +34123456789"),

  is_lawyer: Yup.boolean().required("Este campo es obligatorio"),

  lawyer_membership_number: Yup.string().when("is_lawyer", {
    is: true,
    then: () => Yup.string()
      .required("Número de colegiado obligatorio")
      .matches(numberOnlyRegex, "Escribe un número valido"),
    otherwise: () => Yup.string().optional(),
  }),

  province_id: Yup.number().when("is_lawyer", {
    is: true,
    then: () => Yup.number().required("Localidad del colegio obligatoria"),
    otherwise: () => Yup.number().optional(),
  }),

  accepts_emails: Yup.boolean().optional(),

  // NUEVO: campos de sociedad
  acts_on_behalf_of_company: Yup.boolean().optional(),
  company_name: Yup.string().when('acts_on_behalf_of_company', {
    is: true,
    then: () => Yup.string().required('Razón social obligatoria'),
    otherwise: () => Yup.string().optional()
  }),
  company_tax_id: Yup.string().when('acts_on_behalf_of_company', {
    is: true,
    then: () => Yup.string()
      .required('NIF/CIF obligatorio')
      .matches(cifRegex, 'Formato válido: letra + 7 números + letra o número (p.ej. B1234567C)'),
    otherwise: () => Yup.string().optional()
  })
});

// Create a validation schema for the login form
export const loginSchema = Yup.object().shape({
  id_number: Yup.string()
    .required("Este campo es obligatorio")
    .test(
      "idFormat",
      "Solo se admite DNI o NIE",
      function (value) {
        // Restringir a DNI o NIE
        return (
          nifRegex.test(value) ||
          nieRegex.test(value)
        );
      }
    ),

  password: Yup.string()
    .required("Este campo es obligatorio")
    .min(8, "La contraseña debe tener al menos 8 caracteres"),
});
